/**
 * Optimize Next のプレビュー用クエリ `?_optx_preview=<experimentId>-<pattern>` から
 * 実験 ID（`<experimentId>` 部）を取り出す純粋ロジック。
 *
 * Vue/Nuxt に一切依存しない（core/ 配下）。Vitest でテストする。
 *
 * プレビューでは「どの実験を見るか」を URL が決めるため、env に焼き込まれた experiment ID には依存せず、
 * URL から実験 ID を直接取り出す。これによりデプロイに焼き込まれた値とプレビュー対象がズレても動作する。
 *
 * - `_optx_preview` が無い / 値が空 → null（プレビューではない）
 * - `RL7CHN-1` → `RL7CHN`（`-<pattern>` を除いた実験 ID）
 * - `RL7CHN`（pattern 無し）→ `RL7CHN`
 * - 複数実験（カンマ区切り `RL7CHN-1,ABC-2`）→ 先頭の `RL7CHN`
 * - experiment ID 部が空（`-1` など）→ null
 *
 * @param search `window.location.search`（`?` 付き / 無しどちらも可）
 */
export const parseOptxPreviewExperimentId = (search: string): string | null => {
  const raw = new URLSearchParams(search).get('_optx_preview');
  if (!raw) return null;
  // 複数実験はカンマ区切り。先頭を採用する。
  const first = raw.split(',')[0] ?? '';
  // `<experimentId>-<pattern>` の experiment ID 部（experiment ID にハイフンは含まれない前提）。
  const experimentId = first.split('-')[0]?.trim() ?? '';
  return experimentId ? experimentId : null;
};
